import React from "react"

const Main = ({ children }) => (
  <div id="mainContent" className="flex-auto mt-0 mb-12">
    {children}
  </div>
)

export default Main
